import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import { FaCircleInfo } from "react-icons/fa6";

export interface MessageBoxProps {
  message: string;
}

export const MessageBox = ({ message }: MessageBoxProps) => {
  const borderColor = useColorModeValue(
    "border.lightMode.light",
    "border.darkMode.light"
  );

  const backgroundColor = useColorModeValue(
    "neutral.lightMode.neutral",
    "neutral.darkMode.neutral"
  );
  
  return (
    <Box
      borderRadius="10px"
      border="1px solid"
      borderColor={borderColor}
      py={2}
      px={4}
      m={4}
      width="fit-content"
      backgroundColor={backgroundColor}
    >
    <Flex alignItems="center" justifyContent="center" gap={3}>
      <FaCircleInfo color="#193E8E" size={16}/>
      <Box>{message}</Box>
      </Flex>
    </Box>
  )
}